import WrapperService from "@/modules/core/services/wrapper-service";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/facilitytype"

const serviceName = "FacilityType-Service: ";
export default class FacilityTypeService {

  static async readAllFromAPI(successF, errorF) {
    await WrapperService.get(API_URL, null, serviceName, successF, errorF);
  }

  static async readFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + "/" + id, null, serviceName, successF, errorF);
  }

  static postToAPI(facilityType, successF, errorF) {
    WrapperService.post(API_URL, facilityType, serviceName, successF, errorF)
  }

  static putToAPI(facilityType, successF, errorF) {
    WrapperService.put(API_URL + "/" + facilityType.id, facilityType, serviceName, successF, errorF)
  }

  static deleteFromAPI(facilityType, successF, errorF) {
    WrapperService.delete(API_URL + "/" + facilityType.id, serviceName, successF, errorF)
  }

  static async readRequiredRolesForFacilityFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + "/" + id + "/roles", null, serviceName, successF, errorF);
  }

  static async readRequiredDocumentaitonsForFacilityFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + "/" + id + "/documentations", null, serviceName, successF, errorF);
  }

  static async readRequiredContractTypesForFacilityFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + "/" + id + "/contracts", null, serviceName, successF, errorF);
  }

  static async uploadIcon(typeId, file, progress, successF, errorF) {
    let formData = new FormData();
    formData.append("icon", file, file.name);
    await WrapperService.monitoringPost(API_URL + "/" + typeId + "/upload/icon", formData, serviceName, progress, successF, errorF);
  }
}